export function copyToClipboard(text){
    try {
        navigator.clipboard.writeText(text)
    } catch (error) {
        console.log("CLipboard copy error: ", error);
    }
  };
